module.exports = __webpack_public_path__ + "img/cross4yellow.b8563de5.png";